import { assert } from 'cadenza/utils/custom-error';

const ISOCHRONE_COLOR_PALETTE = [
  '#24a163',
  '#89b648',
  '#d1c83c',
  '#fdd13a',
  '#feaa32',
  '#f4652a',
  '#da1e28',
  '#bc1785',
  '#9511a4',
  '#741e69',
  '#353b44', // gray-08
  '#6d7177', // gray-06
  '#9a9da2', // gray-05
  '#bdbfc2', // gray-04
  '#d7d8da', // gray-03
  '#ebeced', // gray-02
  '#f3f4f4', // gray-01
  '#ffffff' // white
];

/**
 * For a zone index and a given number of zones, returns the color to use for that zone.
 * The assumed order for the zones if from larger to smaller zone,
 * which is the order in which they are added to the map layers.
 *
 * @param {number} zoneIndex - Index of the zone (starting with 0)
 * @param {number} totalNumberOfZones - Total number of zones
 * @return {string} Color
 */
export function determineIsochroneZoneColorOutsideIn (zoneIndex, totalNumberOfZones) {
  assert(zoneIndex >= 0, 'Zone index must not be a negative number.');
  assert(zoneIndex < totalNumberOfZones, 'Zone index must should be between 0 and a total number of zones - 1.');
  return determineIsochroneZoneColorInsideOut(totalNumberOfZones - zoneIndex - 1);
}

/**
 * For a zone index and a given number of zones, returns the color to use for that zone.^
 * The assumed order for the zones if from smaller to larger zone,
 * which is the order in which they are displayed in the UI.
 *
 * @param {number} zoneIndex - Index of the zone (starting with 0)
 * @return {string} Color
 */
export function determineIsochroneZoneColorInsideOut (zoneIndex) {
  assert(zoneIndex >= 0, 'Zone index must not be a negative number.');
  const zoneColorIndex = zoneIndex < ISOCHRONE_COLOR_PALETTE.length ? zoneIndex : ISOCHRONE_COLOR_PALETTE.length - 1;
  return ISOCHRONE_COLOR_PALETTE[zoneColorIndex];
}
